var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              disabled: _vm.isLoading,
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onBeforeSaveItem.apply(null, arguments)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-8" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialTextarea",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3|max:100",
                                expression: "'required|min:3|max:100'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              id: "input-title",
                              name: "title",
                              rows: 2,
                              "input-classes": [
                                { "is-invalid": _vm.fnHasError(`title`) },
                              ],
                              error: _vm.fnFirstError(`title`),
                              helpText: `${_vm.pageID}.help.title`,
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "title",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.title",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.title`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialTextarea",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "min:3|max:500",
                                expression: "'min:3|max:500'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              id: "input-subtitle",
                              name: "subtitle",
                              rows: 3,
                              "input-classes": [
                                { "is-invalid": _vm.fnHasError(`subtitle`) },
                              ],
                              error: _vm.fnFirstError(`subtitle`),
                              helpText: `${_vm.pageID}.help.subtitle`,
                            },
                            model: {
                              value: _vm.form.subtitle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "subtitle",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.subtitle",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.subtitle`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "city-label" }, [
                        _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.content`))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "city-form-group",
                          class: { "is-invalid": _vm.fnHasError("content") },
                        },
                        [
                          _c("ckeditor", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:50",
                                expression: "'required|min:50'",
                              },
                            ],
                            attrs: {
                              name: "content",
                              disabled: _vm.readonlyFormItem,
                              editor: _vm.cKEditor.editor,
                              config: _vm.cKEditor.editorConfig,
                            },
                            model: {
                              value: _vm.form.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "content", $$v)
                              },
                              expression: "form.content",
                            },
                          }),
                          _vm._v(" "),
                          _vm.fnFirstError("content")
                            ? _c(
                                "small",
                                { staticClass: "d-block invalid-feedback" },
                                [_vm._v(_vm._s(_vm.fnFirstError("content")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("HelpSpan", {
                            attrs: { helpText: `${_vm.pageID}.help.content` },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("UploadMultipleFile", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        attrs: {
                          acceptTypes: _vm.acceptTypes,
                          maxFiles: _vm.maxFiles,
                          name: "files",
                        },
                        model: {
                          value: _vm.form.files,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "files", $$v)
                          },
                          expression: "form.files",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col photos" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("h6", { staticClass: "font-weight-normal" }, [
                            _vm._v(
                              _vm._s(_vm.$t(`${_vm.pageID}.model.thumbnail`))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mt-2 mb-0" }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "photo" },
                            [
                              _c("UploadSingleImage", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "",
                                    expression: "''",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.readonlyFormItem,
                                  imageClass: "background-contain",
                                  name: "thumbnail",
                                },
                                model: {
                                  value: _vm.form.thumbnail,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "thumbnail", $$v)
                                  },
                                  expression: "form.thumbnail",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              disabled: _vm.readonlyFormItem,
                              id: "input-published",
                              name: "published",
                              label: "name",
                              options: _vm.lists.onoff,
                              reduce: (option) => option.bool,
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("published") },
                              ],
                              error: _vm.fnFirstError("published"),
                              helpText: `${_vm.pageID}.help.published`,
                            },
                            model: {
                              value: _vm.form.published,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "published",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.published",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  _vm.$t(`${_vm.pageID}.model.published`)
                                ) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialDateRangePicker",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-period",
                              disabled: _vm.readonlyFormItem,
                              name: "published_at",
                              inputClasses: [
                                {
                                  "is-invalid": _vm.fnHasError(`published_at`),
                                },
                              ],
                              error: _vm.fnFirstError(`published_at`),
                              singleDatePicker: true,
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "dateRange",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  _vm.$t(`${_vm.pageID}.model.published_at`)
                                ) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.isSingleLocale
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialSelect",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: _vm.form.locale != null,
                                    },
                                    expression: "{required:form.locale!=null}",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  disabled: _vm.readonlyFormItem,
                                  id: "input-locale",
                                  label: "name",
                                  name: "locale",
                                  options: _vm.getLocale,
                                  reduce: (option) => option.code,
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("locale") },
                                  ],
                                  error: _vm.fnFirstError("locale"),
                                  helpText: `${_vm.pageID}.help.locale`,
                                },
                                model: {
                                  value: _vm.form.locale,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "locale",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.locale",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.locale`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSingleLocale
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialSelect",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  id: "input-news",
                                  name: "news_id",
                                  disabled: _vm.readonlyFormItem,
                                  label: "title",
                                  options: _vm.lists.availabelTranslations,
                                  reduce: (option) => option.news_id,
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("news_id") },
                                  ],
                                  error: _vm.fnFirstError("news_id"),
                                  helpText: `${_vm.pageID}.help.news`,
                                },
                                model: {
                                  value: _vm.form.news_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "news_id",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.news_id",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t(`${_vm.pageID}.model.news`)) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-news_category_id",
                              name: "news_category_id",
                              disabled: _vm.readonlyFormItem,
                              label: "name",
                              filterable: true,
                              options: _vm.lists.categories,
                              reduce: (option) => option.news_category_id,
                              inputClasses: [
                                {
                                  "is-invalid":
                                    _vm.fnHasError("news_category_id"),
                                },
                              ],
                              error: _vm.fnFirstError("news_category_id"),
                              helpText: `${_vm.pageID}.help.category`,
                            },
                            model: {
                              value: _vm.form.news.news_category_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.news,
                                  "news_category_id",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.news.news_category_id",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.category`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-roles",
                              name: "roles",
                              disabled: _vm.readonlyFormItem,
                              filterable: false,
                              options: _vm.lists.roles,
                              reduceObject: true,
                              multiple: true,
                              label: "name",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("roles") },
                              ],
                              error: _vm.fnFirstError("roles"),
                              helpText: `${_vm.pageID}.help.roles`,
                            },
                            model: {
                              value: _vm.form.news.roles,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.news,
                                  "roles",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.news.roles",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.roles`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|integer|min_value:1",
                                expression: "'required|integer|min_value:1'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-order",
                              name: "order",
                              disabled: _vm.readonlyFormItem,
                              readonly: _vm.readonlyFormItem,
                              type: "number",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError(`order`) },
                              ],
                              error: _vm.fnFirstError(`order`),
                              helpText: `${_vm.pageID}.help.order`,
                            },
                            model: {
                              value: _vm.form.order,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "order",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.order",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t(`${_vm.pageID}.model.order`)) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.onBeforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }